import { ReactElement } from 'react';
import { parseZone } from 'moment/moment';
import { useNavigate } from 'react-router-dom';
import { Component as DeliveryIcon } from 'icons/icon-circle--delivery.svg';
import { Component as CheckCircleIcon } from 'icons/icon--check-circle.svg';
import { Component as ShippingIcon } from 'icons/icon--circle-shipping.svg';
import { Component as MakeItYoursIcon } from 'icons/icon--make-it-yours.svg';
import styles from './OrderConfirmation.module.scss';
import { useUser } from '../../contexts/UserContext';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import { useAddress } from '../../contexts/AddressContext';
import { formatAddressString } from '../../utils/address';
import { Route } from '../../utils/config';

export function OrderInformation(): ReactElement {
  const navigate = useNavigate();
  const { user } = useUser();
  const {
    menu,
    cart,
  } = useMenuWithCart();
  const { addresses } = useAddress();

  const shippingAddress = addresses.find((a) => a.id === cart?.shippingAddressId);

  const estimatedArrival = menu?.deliveryOn
    ? parseZone(menu.deliveryOn)
      .format('ddd, MMM DD, YYYY')
    : null;
  return (
    <div className={styles.order_information}>
      <div className={styles.heading_row}>
        <CheckCircleIcon className={styles.check_circle_icon} />
        <h2 className={styles.heading}>
          {user?.firstName ? `Your first delivery is scheduled, ${user.firstName}!` : 'Your first delivery is scheduled!'}
        </h2>
        <button
          className={styles.close_button}
          onClick={() => {
            localStorage.setItem('showWelcomeSurvey', new Date().toUTCString());
            navigate(Route.HUB);
            window.scrollTo(0, 0);
          }}
          aria-label="Go to upcoming menus"
          type="button"
        >
          ×
        </button>
      </div>

      {user?.email && (
        <p className={styles.sub_header}>
          Get ready for an easier way to eat well, every week. We’ll send you an email confirmation
          to
          {' '}
          <strong>{user.email}</strong>
          .
        </p>
      )}

      <div className={styles.delivery_info_row}>
        {estimatedArrival && (
          <div className={styles.delivery_info_inner_row}>
            <DeliveryIcon />
            <div className={styles.delivery_info_item}>
              <span className={styles.info_label}>Arrives on: </span>
              <span className={styles.info_value}>{estimatedArrival}</span>
            </div>
          </div>
        )}

        {shippingAddress && (
          <div className={styles.delivery_info_inner_row}>
            <ShippingIcon />
            <div className={styles.delivery_info_item}>
              <span className={styles.info_label}>Shipping To:</span>
              <span className={styles.info_value}>
                {formatAddressString({
                  ...shippingAddress,
                  city: shippingAddress.city
                    .replace(/\b\w+/g, (w) => w.charAt(0)
                      .toUpperCase() + w.slice(1)
                      .toLowerCase()),
                })}
              </span>
            </div>
          </div>
        )}

        <div className={styles.delivery_info_inner_row}>
          <MakeItYoursIcon />
          <div className={styles.delivery_info_item}>
            <span className={styles.info_label}>Make it yours: </span>
            <span className={styles.info_value}>Adjust by Tuesday, 11:59PM EST</span>
          </div>
        </div>
      </div>
    </div>
  );
}
